
<h1>Please choose the route you want to take.</h1>

<ul class="nav nav-pills mb-4">
<!--  <li class="nav-item">
    <a class="nav-link" [class.active]="direction === 'Entrada'" (click)="direction = 'Entrada'">Entrada</a>
  </li>-->
  <li class="nav-item">
    <a class="nav-link" [class.active]="direction === 'Inbound'" (click)="direction = 'Inbound'">In</a>
  </li>
</ul>

<div class="list-group">
  <a class="list-group-item list-group-item-action"
      *ngFor="let route of routes | directionFilter:direction"
      (click)="chooseRoute(route)">
    {{ route.name }}
  </a>
</div>
